import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ConciergeChat from "@/components/ConciergeChat";
import ScrollToTop from "@/components/ScrollToTop";
import { initTracking } from "@/lib/tracking";

import Landing from "@/pages/Landing";
import BuyerFunnel from "@/pages/BuyerFunnel";
import SellerFunnel from "@/pages/SellerFunnel";
import Listings from "@/pages/Listings";
import PropertyDetail from "@/pages/PropertyDetail";
import Favorites from "@/pages/Favorites";
import HomeValue from "@/pages/HomeValue";
import BookCall from "@/pages/BookCall";
import Financing from "@/pages/Financing";
import MlsSearch from "@/pages/MlsSearch";
import Neighborhoods from "@/pages/Neighborhoods";
import NeighborhoodDetail from "@/pages/NeighborhoodDetail";
import SoldGallery from "@/pages/SoldGallery";
import Login from "@/pages/Login";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Prospects from "@/pages/dashboard/Prospects";
import Overview from "@/pages/dashboard/Overview";
import Leads from "@/pages/dashboard/Leads";
import LeadDetail from "@/pages/dashboard/LeadDetail";
import Properties from "@/pages/dashboard/Properties";
import Alerts from "@/pages/dashboard/Alerts";
import Settings from "@/pages/dashboard/Settings";

function App() {
  useEffect(() => {
    initTracking();
  }, []);

  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/buy" element={<BuyerFunnel />} />
            <Route path="/sell" element={<SellerFunnel />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/listings/:id" element={<PropertyDetail />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/home-value" element={<HomeValue />} />
            <Route path="/book" element={<BookCall />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/mls-search" element={<MlsSearch />} />
            <Route path="/neighborhoods" element={<Neighborhoods />} />
            <Route path="/neighborhoods/:slug" element={<NeighborhoodDetail />} />
            <Route path="/sold" element={<SoldGallery />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="leads" element={<Leads />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="prospects" element={<Prospects />} />
              <Route path="properties" element={<Properties />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
          <ConciergeChat />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#101116",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
